__turbopack_context__.v({
  "className": "plus_jakarta_sans_fa83f162-module__cuDjlG__className",
  "variable": "plus_jakarta_sans_fa83f162-module__cuDjlG__variable",
});
